import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import type { Property } from 'csstype';
import { GetDataForThanksForRSVPQuery } from '@graphql/generated';
import { useHeaderController } from './Header.controller';
import { StyledText } from './Header.styles';
import { CheckOutline } from '@withjoy/joykit/icons';

interface HeaderProps
  extends Readonly<{
    queryData?: GetDataForThanksForRSVPQuery;
    withMessage?: boolean;
  }> {}

export const Header: React.FC<HeaderProps> = ({ queryData, withMessage }) => {
  const { coupleNames, location, date, fontFamily, fontTextTransform, tCongratulationsCard } = useHeaderController(queryData);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <StyledText
        typographyVariant="hed2"
        fontSize={['30px', null, '40px']}
        fontFamily={fontFamily}
        textTransform={fontTextTransform as Property.TextTransform}
      >
        {coupleNames}
      </StyledText>
      {location && (
        <TextV2
          typographyVariant="body2"
          textAlign="center"
          padding="0 50px 10px"
        >
          {location}
        </TextV2>
      )}
      {date && <TextV2 typographyVariant="body2">{date}</TextV2>}
      {withMessage && (
        <>
          <CheckOutline
            size="xxl"
            marginTop="48px"
            marginBottom="8px"
          />
          <TextV2 typographyVariant="hed3">{tCongratulationsCard.yourRSVPComplete()}</TextV2>
          <TextV2
            typographyVariant="hed3"
            marginBottom="42px"
          >
            {tCongratulationsCard.noteOfCongrats()}
          </TextV2>
        </>
      )}
    </Flex>
  );
};
